export default __webpack_public_path__ + "static/media/van.684ac817.svg";